import Joi from "joi";
export const gratuitySchema = Joi.object({
    gratuity_act_no: Joi.string().min(3).max(255).required().messages({
        "string.min": "Gratuity Act No must be at least 3 characters.",
        "string.max": "Gratuity Act No must not exceed 255 characters.",
        "string.empty": "Gratuity Act No is required.",
    }),
    gratuity_type: Joi.number().integer()
        .required()
        .messages({
            "number.base": "Gratuity type is required.",
            "any.required": "Gratuity type is required.",
            "number.empty": "Gratuity type is required.",
        }),
    coverage_date: Joi.date()
        .required()
        .messages({
            "date.base": "Gratuity act coverage date is required.",
            "any.required": "Gratuity act coverage date is required.",
        }),
})
